var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact-notes" }, [
    _c("div", { staticClass: "user-info-content-title" }, [
      _vm._v(_vm._s(_vm.$t("message.notes"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "notes" },
      _vm._l(_vm.notes, function (note) {
        return _c("ContactNoteItem", {
          key: note._id,
          attrs: { note: note, "visitor-id": _vm.visitorId },
          on: {
            "note-updated": _vm.noteUpdated,
            "note-deleted": _vm.noteDeleted,
          },
        })
      }),
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "fixed-bottom-area" }, [
      _c("div", { staticClass: "fixed-bottom-area-header" }, [
        _c("div", { staticClass: "material-icons" }, [_vm._v("draw")]),
        _vm._v(" "),
        _c("span", { staticClass: "fixed-bottom-area-title" }, [
          _vm._v(_vm._s(_vm.$t("message.addNote"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fixed-bottom-area-content" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.description,
              expression: "description",
            },
          ],
          staticClass: "non-resizable",
          attrs: { placeholder: _vm.$t("message.addUserNote") },
          domProps: { value: _vm.description },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.description = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fixed-bottom-area-footer" }, [
        _c(
          "div",
          { staticClass: "contact-notes-form-actions" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.isPrivate,
                  callback: function ($$v) {
                    _vm.isPrivate = $$v
                  },
                  expression: "isPrivate",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.privateNote")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "contact-notes-form-actions-buttons" }, [
              _c(
                "div",
                {
                  staticClass: "custom-submit-button",
                  on: { click: _vm.submitForm },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("message.send")))])]
              ),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }